<div class="flex flex-col sm:flex-row gap-2 justify-center">
    @if (isVisible == undefined) {
        <loading [isLoading]="true" [success]="false"></loading>
    } @else if (isVisible) {
        <div class="flex flex-col w-[360px] sm:min-w-[360px] sm:max-w-[720px] gap-2 grow">
            <collection-previews [username]="username"></collection-previews>
            @if (isOwnCollection) {
                <div class="font-bold border-b border-ponder-light border-opacity-10">
                    Tools
                </div>
                <div class="grid grid-cols-2 gap-2 text-sm">
                    <a href="/user/{{ username }}/collection/import" class="bg-slate-100 rounded shadow-sm p-2 flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link">
                        <div class="grow">Import Collection</div>
                        <svg class="w-4 h-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="importSvgIcon" />
                        </svg>
                    </a>
                    <a href="/user/{{ username }}/collection/export" class="bg-slate-100 rounded shadow-sm p-2 flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link">
                        <div class="grow">Export Collection</div>
                        <svg class="w-4 h-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="exportSvgIcon" />
                        </svg>
                    </a>
                </div>
            }
        </div>
    } @else {
        <div class="flex flex-col w-[360px] gap-1 bg-slate-100 rounded shadow-sm p-8 text-slate-600 text-center text-sm italic">
            Collection contents for this user are private.
        </div>
    }
</div>